// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as App_Context$DvmAdminFrontendFr from "../../app/App_Context.bs.js";

var initialState = {
  modelVersionGridManage: undefined,
  modelVersionGridFilter: undefined,
  modelVersionFilter: undefined,
  ordersFilter: undefined,
  ordersModalFilter: undefined,
  ordersModalAdditionalFilter: undefined,
  ordersModalVOFilter: undefined,
  dealersFilter: undefined,
  flashFilter: undefined,
  flashModalFilter: undefined,
  flashMoreDatesFilter: undefined,
  flashAdditionalFilter: undefined,
  contractsFilter: undefined,
  managersFilter: undefined,
  categoryFilter: undefined,
  bonusesFilter: undefined,
  bonusesModalFilter: undefined,
  bonusesModalAdditionalFilter: undefined,
  bonusesModalAdditionalSecondFilter: undefined,
  bonusesModalVOFilter: undefined,
  bonusesPERFFilter: undefined,
  gemoFilter: undefined,
  submarketFilter: undefined,
  quotaViewFilter: undefined,
  quotaAdminFilter: undefined,
  quotaExclusionsFilter: undefined,
  brandsFilter: undefined,
  energyFilter: undefined,
  quotaPARCFilter: undefined,
  bonusAnomaliesFilter: undefined,
  pcdAgreementFilter: undefined,
  actionReferentialFilter: undefined,
  poolExpensesFilter: undefined
};

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* StoreModelVersionManageContract */0 :
        var newrecord = Caml_obj.obj_dup(state);
        newrecord.modelVersionGridManage = action._0;
        return newrecord;
    case /* StoreModelVersionGridFilter */1 :
        var newrecord$1 = Caml_obj.obj_dup(state);
        newrecord$1.modelVersionGridFilter = action._0;
        return newrecord$1;
    case /* StoreModelVersionFilter */2 :
        var newrecord$2 = Caml_obj.obj_dup(state);
        newrecord$2.modelVersionFilter = action._0;
        return newrecord$2;
    case /* StoreOrdersFilter */3 :
        var newrecord$3 = Caml_obj.obj_dup(state);
        newrecord$3.ordersFilter = action._0;
        return newrecord$3;
    case /* StoreOrdersModalFilter */4 :
        var newrecord$4 = Caml_obj.obj_dup(state);
        newrecord$4.ordersModalFilter = action._0;
        return newrecord$4;
    case /* StoreOrdersModalAdditionalFilter */5 :
        var newrecord$5 = Caml_obj.obj_dup(state);
        newrecord$5.ordersModalAdditionalFilter = action._0;
        return newrecord$5;
    case /* StoreOrdersModalVOFilter */6 :
        var newrecord$6 = Caml_obj.obj_dup(state);
        newrecord$6.ordersModalVOFilter = action._0;
        return newrecord$6;
    case /* StoreDealersFilter */7 :
        var newrecord$7 = Caml_obj.obj_dup(state);
        newrecord$7.dealersFilter = action._0;
        return newrecord$7;
    case /* StoreFlashFilter */8 :
        var newrecord$8 = Caml_obj.obj_dup(state);
        newrecord$8.flashFilter = action._0;
        return newrecord$8;
    case /* StoreFlashModalFilter */9 :
        var newrecord$9 = Caml_obj.obj_dup(state);
        newrecord$9.flashModalFilter = action._0;
        return newrecord$9;
    case /* StoreFlashMoreDatesFilter */10 :
        var newrecord$10 = Caml_obj.obj_dup(state);
        newrecord$10.flashMoreDatesFilter = action._0;
        return newrecord$10;
    case /* StoreFlashModalAdditionalFilter */11 :
        var newrecord$11 = Caml_obj.obj_dup(state);
        newrecord$11.flashAdditionalFilter = action._0;
        return newrecord$11;
    case /* StoreContractsFilter */12 :
        var newrecord$12 = Caml_obj.obj_dup(state);
        newrecord$12.contractsFilter = action._0;
        return newrecord$12;
    case /* StoreManagersFilter */13 :
        var newrecord$13 = Caml_obj.obj_dup(state);
        newrecord$13.managersFilter = action._0;
        return newrecord$13;
    case /* StoreCategoryFilter */14 :
        var newrecord$14 = Caml_obj.obj_dup(state);
        newrecord$14.categoryFilter = action._0;
        return newrecord$14;
    case /* StoreBonusesFilter */15 :
        var newrecord$15 = Caml_obj.obj_dup(state);
        newrecord$15.bonusesFilter = action._0;
        return newrecord$15;
    case /* StoreBonusesModalFilter */16 :
        var newrecord$16 = Caml_obj.obj_dup(state);
        newrecord$16.bonusesModalFilter = action._0;
        return newrecord$16;
    case /* StoreBonusesModalAdditionalFilter */17 :
        var newrecord$17 = Caml_obj.obj_dup(state);
        newrecord$17.bonusesModalAdditionalFilter = action._0;
        return newrecord$17;
    case /* StoreBonusesModalAdditionalSecondFilter */18 :
        var newrecord$18 = Caml_obj.obj_dup(state);
        newrecord$18.bonusesModalAdditionalSecondFilter = action._0;
        return newrecord$18;
    case /* StoreBonusesModalVOFilter */19 :
        var newrecord$19 = Caml_obj.obj_dup(state);
        newrecord$19.bonusesModalVOFilter = action._0;
        return newrecord$19;
    case /* StoreBonusesPERFFilter */20 :
        var newrecord$20 = Caml_obj.obj_dup(state);
        newrecord$20.bonusesPERFFilter = action._0;
        return newrecord$20;
    case /* StoreGemoFilter */21 :
        var newrecord$21 = Caml_obj.obj_dup(state);
        newrecord$21.gemoFilter = action._0;
        return newrecord$21;
    case /* StoreSubmarketFilter */22 :
        var newrecord$22 = Caml_obj.obj_dup(state);
        newrecord$22.submarketFilter = action._0;
        return newrecord$22;
    case /* StoreQuotaViewFilter */23 :
        var newrecord$23 = Caml_obj.obj_dup(state);
        newrecord$23.quotaViewFilter = action._0;
        return newrecord$23;
    case /* StoreQuotaAdminFilter */24 :
        var newrecord$24 = Caml_obj.obj_dup(state);
        newrecord$24.quotaAdminFilter = action._0;
        return newrecord$24;
    case /* StoreQuotaExclusionsFilter */25 :
        var newrecord$25 = Caml_obj.obj_dup(state);
        newrecord$25.quotaExclusionsFilter = action._0;
        return newrecord$25;
    case /* StoreBrandsFilter */26 :
        var newrecord$26 = Caml_obj.obj_dup(state);
        newrecord$26.brandsFilter = action._0;
        return newrecord$26;
    case /* StoreEnergyFilter */27 :
        var newrecord$27 = Caml_obj.obj_dup(state);
        newrecord$27.energyFilter = action._0;
        return newrecord$27;
    case /* StoreQuotaPARCFilter */28 :
        var newrecord$28 = Caml_obj.obj_dup(state);
        newrecord$28.quotaPARCFilter = action._0;
        return newrecord$28;
    case /* StoreBonusAnomaliesFilter */29 :
        var newrecord$29 = Caml_obj.obj_dup(state);
        newrecord$29.bonusAnomaliesFilter = action._0;
        return newrecord$29;
    case /* StorePCDAgreementFilter */30 :
        var newrecord$30 = Caml_obj.obj_dup(state);
        newrecord$30.pcdAgreementFilter = action._0;
        return newrecord$30;
    case /* StoreActionReferentialFilter */31 :
        var newrecord$31 = Caml_obj.obj_dup(state);
        newrecord$31.actionReferentialFilter = action._0;
        return newrecord$31;
    case /* StorePoolExpensesFilter */32 :
        var newrecord$32 = Caml_obj.obj_dup(state);
        newrecord$32.poolExpensesFilter = action._0;
        return newrecord$32;
    
  }
}

function defaultValue_1(param) {
  
}

var defaultValue = [
  initialState,
  defaultValue_1
];

var include = App_Context$DvmAdminFrontendFr.Make({
      defaultValue: defaultValue
    });

var Provider = include.Provider;

var Context_t = include.t;

var Context_useAppContext = include.useAppContext;

var Context = {
  t: Context_t,
  Provider: Provider,
  useAppContext: Context_useAppContext
};

function Context_Router$Provider(Props) {
  var children = Props.children;
  var match = React.useReducer(reducer, initialState);
  return React.createElement(Provider.make, {
              value: [
                match[0],
                match[1]
              ],
              children: children
            });
}

var Provider$1 = {
  make: Context_Router$Provider
};

export {
  initialState ,
  reducer ,
  Context ,
  Provider$1 as Provider,
}
/* include Not a pure module */
